var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLukeTimelineIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/luke_timeline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Log-Entry",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeOpacity: 0.87
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-526.000000, -533.000000)",
    stroke: "#000000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(78.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(449.000000, 381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "luke_timeline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8687186,12.4563558 L10.8687186,10.2526063 C11.8346422,9.13953164 12.1029562,8.08416112 12.1029562,6.86600851 C12.1029562,4.91078002 10.7077371,3.42549783 8.18557815,3.42549783 C5.6634192,3.42549783 4.53651411,5.28528316 4.53651411,6.69536558 L4.53651411,7.811362 C4.53651411,8.07473506 4.52379682,8.07553506 4.48057192,8.14325658 C4.27181373,8.47045553 3.89675781,8.90221066 3.78522089,9.07608837 C3.62423942,9.32711365 3.20165001,9.63643439 3.5437313,9.94982469 C3.59074359,9.99288542 4.07702371,10.080433 4.14179156,10.0894764 C4.33609513,10.1165372 4.50965491,10.2172673 4.50965491,10.589927 L4.50965491,11.4897154 C4.50965491,11.6913495 4.73971283,12.4058168 5.41049794,12.2849476 C6.08128305,12.1640784 8.18557815,11.8388969 8.52098808,11.7448798 C8.85636326,11.6508627 9.25883433,11.3285681 9.25883433,10.8719435 L9.25883433,8.92172365",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5512952,7.31810901 C10.5512952,8.0920154 9.92605723,8.71944903 9.15478325,8.71944903 C8.38350927,8.71944903 7.75830528,8.0920154 7.75830528,7.31810901 C7.75830528,6.54416854 8.38350927,5.91676899 9.15478325,5.91676899 C9.92605723,5.91676899 10.5512952,6.54416854 10.5512952,7.31810901 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8269428,7.9409268 C15.8269428,12.326592 12.2839733,15.8818536 7.91347139,15.8818536 C3.54296946,15.8818536 0,12.326592 0,7.9409268 C0,3.55526163 3.54296946,0 7.91347139,0 C12.2839733,0 15.8269428,3.55526163 15.8269428,7.9409268 Z",
    id: "Stroke-5"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLukeTimelineIcon);
export default __webpack_public_path__ + "static/media/luke_timeline_icon.83763b5b4845bfd1a1092a3530147b59.svg";
export { ForwardRef as ReactComponent };